var navigation = (function() {

  // Mobile Menu

  var mobileMenuItemsWithChildren = $(".mobile-menu .mobile-menu-item.has-children");

  mobileMenuItemsWithChildren.each(function() {
    if($(this).parent().find(".submenu ul").children().length == 0) {
      $(this).removeClass("has-children");
      $(this).removeAttr("aria-haspopup").removeAttr("aria-controls").removeAttr("aria-expanded").removeAttr("aria-label");
      $(this).parent().find(".submenu").remove();
    } else {
      var link = $(this).attr("href");
      var linkText = $(this).text();

      //console.log(link[0]);
      $(this).parent().find(".submenu ul").prepend("<li class='current-link'><a href='" + link + "' class='submenu-item'>" + linkText + "</a></li>");
    }
  });

  $(".mobile-menu .mobile-menu-item.has-children").on("click", function(e) {
    e.preventDefault();
    if ($(this).attr("aria-expanded") == "true") {
      $(this).attr("aria-expanded", false);
    } else {
      $(this).attr("aria-expanded", true);
    }
    if ($(this).parent()[0].className == "active") {
      $(this)
        .parent()
        .removeClass("active")
        .find("button")
        .attr("aria-expanded", false);
    } else {
      $(".mobile-menu .mobile-menu-item")
        .parent()
        .removeClass("active")
        .find("button")
        .attr("aria-expanded", false);
      $(this)
        .parent()
        .addClass("active")
        .find("button")
        .attr("aria-expanded", true);
    }
  });

  // Aside navigation

  var sidebarMenuItemsWithChildren = $(".sidebar .aside-menu-item.has-children");

  sidebarMenuItemsWithChildren.each(function() {
    if($(this).parent().find(".submenu ul").children().length == 0) {
      $(this).removeClass("has-children");
      $(this).removeAttr("aria-haspopup").removeAttr("aria-controls").removeAttr("aria-expanded").removeAttr("aria-label");
      $(this).parent().find(".submenu").remove();
    } 
    // else {
    //   var link = $(this).attr("href");
    //   var linkText = $(this).text();
    //   var currentLinkHTML = "<li class='current-link'><a href='" + link + "' class='submenu-item'>" + linkText + "</a></li>";

    //   $(this).parent().find(".submenu ul").prepend(currentLinkHTML);
    // }
  });

  // Open submenu of already open link
  console.log(window.location.pathname);
  $(".sidebar .aside-menu-item[href='" + window.location.pathname + "']").parent().addClass("active");
  $(".sidebar .submenu-item.active").parent().parent().parent().parent().addClass("active");

  $(".sidebar.mobile-sidebar nav .aside-menu-item.has-children").on("click", function(e) {
    e.preventDefault();
    if ($(this).attr("aria-expanded") == "true") {
      $(this).attr("aria-expanded", false);
    } else {
      $(this).attr("aria-expanded", true);
    }
    if ($(this).parent()[0].className == "active") {
      $(this)
        .parent()
        .removeClass("active")
        .find("button")
        .attr("aria-expanded", false);
    } else {
      $(".sidebar nav .aside-menu-item")
        .parent()
        .removeClass("active")
        .find("button")
        .attr("aria-expanded", false);
      $(this)
        .parent()
        .addClass("active")
        .find("button")
        .attr("aria-expanded", true);
    }
  });

  // Update aria expanded on hover

  var desktopMenuItem = $(".menu-item");

  desktopMenuItem.each(function() {
    if($(this).parent().find(".submenu ul").children().length == 0) {
      $(this).removeClass("has-children");
      $(this).removeAttr("aria-haspopup").removeAttr("aria-controls").removeAttr("aria-expanded").removeAttr("aria-label");
      $(this).parent().find(".submenu").remove();
    }
  });

  $(".menu-item").hover(function() {
    $(this).attr("aria-expanded", true);
    // If another menu item is focused, close this menu when another is hovered
    $(".menu-item").each(function() {
      if ($(this).is(":focus")) {
        $(this)
          .removeClass("active")
          .attr("aria-expanded", false)
          .blur();
      }
    });

    // If focus of submenu item and hover another menu close the submenu so two menus can't be shown at the same time

    $(".submenu-item").each(function() {
      // Remove parent submenu open state & blur
      if ($(this).is(":focus")) {
        $(this)
          .parent()
          .parent()
          .parent()
          .parent()
          .removeClass("open")
          .blur();
        // Remove this submenu's menu item open state and blur
        $(this)
          .parent()
          .parent()
          .parent()
          .parent()
          .find(".menu-item")
          .removeClass("active")
          .attr("aria-expanded", false)
          .blur();
      }
    });
  });
  // Remove aria states on mouseleave
  $(".menu-item").mouseleave(function() {
    $(this).attr("aria-expanded", false);
  });
  // Add aria states on focus
  $(".menu-item").focus(function() {
    $(this).attr("aria-expanded", true);
  });
  // Remove aria states on blur
  $(".menu-item").blur(function() {
    $(this).attr("aria-expanded", false);
  });

  // If submenus is hovered, show styling over parent's menu link

  $(".submenu").hover(function() {
    $(this)
      .parent()
      .find(".menu-item")
      .toggleClass("active")
      .attr("aria-expanded", true);
  });

  // On focus of submenu link, keep submenu visible for keyboard users

  // Loop through submenus
  $(".submenu").each(function() {
    // Close submenu on blur of parent link
    $(this)
      .parent()
      .parent()
      .parent()
      .find(".menu-item")
      .blur(function() {
        $(this)
          .removeClass("active")
          .attr("aria-expanded", false);
        $(this)
          .next()
          .removeClass("open");
      });

    // Change aria expanded to false on mouseleave
    $(this).mouseleave(function() {
      $(this)
        .parent()
        .parent()
        .parent()
        .find(".menu-item")
        .attr("aria-expanded", false);
      $(this).removeClass("open");
    });

    // Find submenu items of each submenu
    var children = $(this).find(".submenu-item");

    // Loop through the submenu items
    children.each(function(e) {
      var num = e;

      // If a child is focused, keep active state on parent
      $(this).focus(function() {
        $(this)
          .parent()
          .parent()
          .parent()
          .parent()
          .parent()
          .find(".menu-item")
          .addClass("active")
          .attr("aria-expanded", true);
        $(this)
          .parent()
          .parent()
          .addClass("open");
      });
      // On blur of child
      $(this).blur(function() {
        // If last child in this menu, remove active and open state of menu
        if (num === children.length - 1) {
          $(this)
            .parent()
            .parent()
            .parent()
            .parent()
            .parent()
            .find(".menu-item")
            .removeClass("active")
            .attr("aria-expanded", false);

          $(this)
            .parent()
            .parent()
            .removeClass("open");
        }
      });
    });
  });

  // Conference mobile menu 

  var conferenceMobileMenuItems = $(".conference-mobile-navigation .mobile-menu-item.has-children");

  conferenceMobileMenuItems.each(function () {
    if ($(this).parent().find(".submenu ul").children().length == 0) {
      $(this).removeClass("has-children");
      $(this).removeAttr("aria-haspopup").removeAttr("aria-controls").removeAttr("aria-expanded").removeAttr("aria-label");
      $(this).parent().find(".submenu").remove();
    } else {
      var link = $(this).attr("href");
      var linkText = $(this).text();

      //console.log(link[0]);
      $(this).parent().find(".submenu ul").prepend("<li class='current-link'><a href='" + link + "' class='submenu-item'>" + linkText + "</a></li>");
    }
  });

  $(".conference-mobile-navigation .mobile-menu-item.has-children").on("click", function (e) {
    e.preventDefault();
    if ($(this).attr("aria-expanded") == "true") {
      $(this).attr("aria-expanded", false);
    } else {
      $(this).attr("aria-expanded", true);
    }
    if ($(this).parent()[0].className == "active") {
      $(this)
        .parent()
        .removeClass("active")
        .find("button")
        .attr("aria-expanded", false);
    } else {
      $(".mobile-menu .mobile-menu-item")
        .parent()
        .removeClass("active")
        .find("button")
        .attr("aria-expanded", false);
      $(this)
        .parent()
        .addClass("active")
        .find("button")
        .attr("aria-expanded", true);
    }
  });


})();
